module.exports = __webpack_public_path__ + "img/home.77b26a9a.svg";